type Value = "" | "1" | "0";

type ActiveStatusSegmentProps = {
  value: Value;
  onChange: (next: Value) => void;
  isArabic: boolean;
  className?: string;
};

/**
 * Tri-state filter: all / active only / inactive only.
 */
export default function ActiveStatusSegment({
  value,
  onChange,
  isArabic,
  className = "",
}: ActiveStatusSegmentProps) {
  const opts: { v: Value; ar: string; en: string }[] = [
    { v: "", ar: "الكل", en: "All" },
    { v: "1", ar: "نشط", en: "Active" },
    { v: "0", ar: "غير نشط", en: "Inactive" },
  ];
  return (
    <div
      className={`flex flex-wrap rounded-xl border border-gray-200 bg-gray-50/90 p-0.5 dark:border-white/10 dark:bg-navy-900/80 ${className}`}
      role="group"
      aria-label={isArabic ? "تصفية الحالة" : "Status filter"}
    >
      {opts.map(({ v, ar, en }) => {
        const active = value === v;
        return (
          <button
            key={v || "all"}
            type="button"
            onClick={() => onChange(v)}
            className={`rounded-lg px-2.5 py-1.5 text-xs font-semibold transition-colors ${
              active
                ? "bg-white text-brand-600 shadow-sm dark:bg-brand-500/20 dark:text-brand-300"
                : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
            }`}
          >
            {isArabic ? ar : en}
          </button>
        );
      })}
    </div>
  );
}
